export default "__VITE_ASSET__qqYfyqqa__"